// import React, { useState, useEffect } from 'react';
// import { ArrowLeft, ArrowRight, MapPin, ArrowUpRight } from 'lucide-react';
// import { Link } from 'react-router-dom';

// const ProjectSlider = () => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isAnimating, setIsAnimating] = useState(false);

//   // PROJECT DATA
//   const projects = [
//     {
//       id: 1,
//       title: "The Oberoi Villa",
//       location: "Udaipur, Rajasthan",
//       description: "A fusion of Rajasthani heritage and modern minimalism. We used sandstone textures with Italian marble to create a space that feels like a modern palace.",
//       image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2070&auto=format&fit=crop",
//       category: "Residential"
//     },
//     {
//       id: 2,
//       title: "Azure Sky Penthouse",
//       location: "Mumbai, Marine Drive",
//       description: "Designed to capture the ocean view. Floor-to-ceiling glass windows paired with low-height plush furniture to ensure the view remains the protagonist.",
//       image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=2053&auto=format&fit=crop",
//       category: "Penthouse"
//     },
//     {
//       id: 3,
//       title: "Golden Hour Lounge",
//       location: "Delhi, Vasant Vihar",
//       description: "A warm, inviting living space centered around a custom fireplace. The gold accents in the lighting fixtures contrast beautifully with the charcoal walls.",
//       image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?q=80&w=2074&auto=format&fit=crop",
//       category: "Luxury Living"
//     }
//   ];

//   // HANDLE NEXT SLIDE
//   const nextSlide = () => {
//     if (isAnimating) return;
//     setIsAnimating(true);
//     setCurrentIndex((prev) => (prev + 1) % projects.length);
//   };

//   // HANDLE PREV SLIDE
//   const prevSlide = () => {
//     if (isAnimating) return;
//     setIsAnimating(true);
//     setCurrentIndex((prev) => (prev === 0 ? projects.length - 1 : prev - 1));
//   };

//   // Reset animation lock after transition
//   useEffect(() => {
//     const timer = setTimeout(() => setIsAnimating(false), 800); // 800ms matches CSS duration
//     return () => clearTimeout(timer);
//   }, [currentIndex]);

//   return (
//     <section className="relative w-full h-[85vh] bg-neutral-900 overflow-hidden font-sans group">
      
//       {/* 1. BACKGROUND IMAGES (SLIDER) */}
//       {projects.map((project, index) => {
//         // Logic to determine slide position
//         let position = 'translate-x-full opacity-0';
//         if (index === currentIndex) position = 'translate-x-0 opacity-100';
//         if (index === (currentIndex - 1 + projects.length) % projects.length) position = '-translate-x-[20%] opacity-0'; // Slide out to left

//         return (
//           <div 
//             key={project.id}
//             className={`absolute inset-0 w-full h-full transition-all duration-[800ms] ease-[cubic-bezier(0.25,1,0.5,1)] ${position}`}
//           >
//             <img 
//               src={project.image} 
//               alt={project.title} 
//               className="w-full h-full object-cover brightness-[0.85]"
//             />
//             {/* Gradient Overlay for Text Readability */}
//             <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
//           </div>
//         );
//       })}

//       {/* 2. FLOATING CONTENT CARD (Bottom Left Corner) */}
//       <div className="absolute bottom-0 left-0 md:bottom-16 md:left-16 z-20 w-full md:w-[500px]">
//          {/* Overflow hidden ensures text slides up neatly */}
//          <div className="bg-white/95 backdrop-blur-md p-8 md:p-10 shadow-2xl relative overflow-hidden rounded-none md:rounded-sm border-l-4 border-amber-600">
            
//             {/* Dynamic Content with Animation */}
//             {projects.map((project, index) => (
//                index === currentIndex && (
//                  <div key={project.id} className="animate-slide-up">
//                     {/* Category & Location */}
//                     <div className="flex justify-between items-start mb-4">
//                        <span className="text-xs font-bold tracking-[2px] uppercase text-amber-600">
//                          {project.category}
//                        </span>
//                        <div className="flex items-center text-gray-400 gap-1 text-xs uppercase tracking-wider">
//                           <MapPin size={14} /> {project.location}
//                        </div>
//                     </div>

//                     {/* Title */}
//                     <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-6 leading-tight">
//                       {project.title}
//                     </h2>

//                     {/* Description */}
//                     <p className="text-gray-600 text-sm leading-relaxed mb-8 border-l-2 border-gray-200 pl-4">
//                       {project.description}
//                     </p>

//                     {/* Button */}
//                     <Link to="/projects" className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-black border-b border-black pb-1 hover:text-amber-700 hover:border-amber-700 transition-all">
//                       View Project Case <ArrowUpRight size={16} />
//                     </Link>
//                  </div>
//                )
//             ))}
//          </div>
//       </div>

//       {/* 3. NAVIGATION CONTROLS (Bottom Right) */}
//       <div className="absolute bottom-8 right-8 md:bottom-16 md:right-16 z-20 flex items-center gap-6">
         
//          {/* Counter */}
//          <div className="text-white font-serif text-xl hidden md:block">
//             <span className="text-3xl">{currentIndex + 1}</span>
//             <span className="text-white/40 text-lg mx-2">/</span>
//             <span className="text-white/40 text-lg">{projects.length}</span>
//          </div>

//          {/* Buttons */}
//          <div className="flex gap-2">
//             <button 
//               onClick={prevSlide} 
//               disabled={isAnimating}
//               className="w-14 h-14 border border-white/20 bg-black/30 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white hover:text-black hover:scale-105 transition-all duration-300 disabled:opacity-50"
//             >
//                <ArrowLeft size={20} />
//             </button>
//             <button 
//               onClick={nextSlide}
//               disabled={isAnimating} 
//               className="w-14 h-14 bg-amber-600 flex items-center justify-center text-white hover:bg-amber-700 hover:scale-105 transition-all duration-300 disabled:opacity-50 shadow-[0_0_20px_rgba(217,119,6,0.4)]"
//             >
//                <ArrowRight size={20} />
//             </button>
//          </div>
//       </div>

//       {/* 4. PROGRESS BAR (Running at bottom) */}
//       <div className="absolute bottom-0 left-0 w-full h-1 bg-white/10 z-20">
//          <div 
//            className="h-full bg-amber-500 transition-all duration-[800ms] ease-out"
//            style={{ width: `${((currentIndex + 1) / projects.length) * 100}%` }}
//          ></div>
//       </div>

//       {/* CSS For Internal Animations */}
//       <style>{`
//         @keyframes slideUpFade {
//           from { opacity: 0; transform: translateY(20px); }
//           to { opacity: 1; transform: translateY(0); }
//         }
//         .animate-slide-up {
//           animation: slideUpFade 0.6s ease-out forwards;
//         }
//       `}</style>
//     </section>
//   );
// };

// export default ProjectSlider;

import React, { useState, useEffect } from 'react';
import { ArrowLeft, ArrowRight, MapPin, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const ProjectSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  // PROJECT DATA
  const projects = [
    {
      id: 1,
      title: "The Luxuriya Villa",
      location: "Varanasi, Rajasthan",
      description: "A fusion of Rajasthani heritage and modern minimalism. We used sandstone textures with Italian marble to create a space that feels like a modern palace.",
      image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2070&auto=format&fit=crop",
      category: "Residential"
    },
    {
      id: 2,
      title: "Azure Sky Penthouse",
      location: "Delhi, Marine Drive",
      description: "Designed to capture the ocean view. Floor-to-ceiling glass windows paired with low-height plush furniture to ensure the view remains the protagonist.",
      image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=2053&auto=format&fit=crop",
      category: "Penthouse"
    },
    {
      id: 3,
      title: "Golden Hour Lounge",
      location: "Lucknow, Vasant Vihar",
      description: "A warm, inviting living space centered around a custom fireplace. The gold accents in the lighting fixtures contrast beautifully with the charcoal walls.",
      image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?q=80&w=2074&auto=format&fit=crop",
      category: "Luxury Living"
    }
  ];

  // Helper to get next project title
  const nextProjectTitle = projects[(currentIndex + 1) % projects.length].title;

  const nextSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prev) => (prev + 1) % projects.length);
  };

  const prevSlide = () => {
    if (isAnimating) return;
    setIsAnimating(true);
    setCurrentIndex((prev) => (prev === 0 ? projects.length - 1 : prev - 1));
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsAnimating(false), 1000); 
    return () => clearTimeout(timer);
  }, [currentIndex]);

  return (
    <section className="relative w-full h-[90vh] bg-black overflow-hidden font-sans group">
      
      {/* 1. BACKGROUND IMAGES with KEN BURNS EFFECT */}
      {projects.map((project, index) => {
        let position = 'translate-x-full opacity-0 z-0';
        if (index === currentIndex) position = 'translate-x-0 opacity-100 z-10';
        if (index === (currentIndex - 1 + projects.length) % projects.length) position = '-translate-x-[20%] opacity-0 z-0';

        return (
          <div 
            key={project.id}
            className={`absolute inset-0 w-full h-full transition-all duration-[1000ms] ease-[cubic-bezier(0.25,1,0.5,1)] ${position}`}
          >
            {/* Image zooms slowly when active */}
            <img 
              src={project.image} 
              alt={project.title} 
              className={`w-full h-full object-cover transition-transform duration-[10000ms] ease-linear ${
                 index === currentIndex ? 'scale-110' : 'scale-100'
              }`}
            />
            {/* Cinematic Gradient Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-90"></div>
          </div>
        );
      })}

      {/* 2. FLOATING GLASS CARD (Left Side) */}
      <div className="absolute bottom-0 left-0 md:bottom-20 md:left-20 z-30 w-full md:w-[550px]">
         <div className="bg-white/10 backdrop-blur-xl border border-white/10 p-8 md:p-12 shadow-[0_30px_60px_-15px_rgba(0,0,0,0.5)] relative overflow-hidden text-white">
            
            {/* Gold Accent Line */}
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-amber-400 to-amber-700"></div>

            {projects.map((project, index) => (
               index === currentIndex && (
                 <div key={project.id} className="relative">
                    
                    {/* Location & Category (Delay 1) */}
                    <div className="flex justify-between items-center mb-6 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
                       <span className="px-3 py-1 bg-amber-600/20 border border-amber-600/30 text-amber-400 text-[10px] font-bold tracking-[2px] uppercase rounded-full">
                         {project.category}
                       </span>
                       <div className="flex items-center text-gray-300 gap-2 text-xs uppercase tracking-wider">
                          <MapPin size={14} className="text-amber-500" /> {project.location}
                       </div>
                    </div>

                    {/* Title (Delay 2) */}
                    <h2 className="text-4xl md:text-5xl font-serif text-white mb-6 leading-[1.1] animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
                      {project.title}
                    </h2>

                    {/* Description (Delay 3) */}
                    <p className="text-gray-300 text-sm leading-relaxed mb-8 font-light animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
                      {project.description}
                    </p>

                    {/* Link (Delay 4) */}
                    <div className="animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
                      <Link to="/projects" className="group inline-flex items-center gap-3 text-xs font-bold uppercase tracking-widest text-white hover:text-amber-400 transition-colors">
                        Discover Space 
                        <span className="p-2 border border-white/30 rounded-full group-hover:border-amber-400 group-hover:bg-amber-400 group-hover:text-black transition-all duration-300">
                          <ArrowUpRight size={14} />
                        </span>
                      </Link>
                    </div>
                 </div>
               )
            ))}
         </div>
      </div>

      {/* 3. PREMIUM NAVIGATION (Bottom Right) */}
      <div className="absolute bottom-10 right-8 md:bottom-20 md:right-20 z-30 flex flex-col items-end gap-4">
         
         {/* "Next Project" Text Indicator */}
         <div className="hidden md:flex flex-col items-end text-right animate-fade-in opacity-80 mb-2">
            <span className="text-[10px] uppercase tracking-[3px] text-gray-400">Next Project</span>
            <span className="text-lg font-serif text-white">{nextProjectTitle}</span>
         </div>

         {/* Navigation Buttons */}
         <div className="flex items-center gap-0 bg-white/5 backdrop-blur-md border border-white/10 rounded-full overflow-hidden">
            <button 
              onClick={prevSlide} 
              disabled={isAnimating}
              className="w-16 h-16 flex items-center justify-center text-white hover:bg-white hover:text-black transition-all duration-300 border-r border-white/10"
            >
               <ArrowLeft size={20} />
            </button>
            <button 
              onClick={nextSlide}
              disabled={isAnimating} 
              className="w-16 h-16 flex items-center justify-center text-white hover:bg-amber-600 transition-all duration-300"
            >
               <ArrowRight size={20} />
            </button>
         </div>

         {/* Simple Counter (01 / 03) */}
         <div className="text-xs font-bold tracking-[3px] text-gray-500 mt-2">
            <span className="text-white">0{currentIndex + 1}</span> / 0{projects.length}
         </div>
      </div>

      {/* CSS Animations */}
      <style>{`
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          opacity: 0;
        }
        @keyframes fadeInSimple {
          from { opacity: 0; }
          to { opacity: 0.8; }
        }
        .animate-fade-in {
          animation: fadeInSimple 1s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default ProjectSlider;